import React from 'react'
import Link from '@material-ui/core/Link'
import { Typography } from '@material-ui/core'
import Breadcrumbs from '@material-ui/core/Breadcrumbs'
import { Route, MemoryRouter } from 'react-router'
import { Link as RouterLink } from 'react-router-dom'

import useRouter from 'utils/useRouter'
import routes from 'routes'

const LinkRouter = (props) => <Link {...props} component={RouterLink} />

export const RouterBreadcrumbs = (props) => {
  const { linkRetorno, tituloLinkRetorno } = props
  const router = useRouter()
  let breadcrumbNameMap = {}

  routes[4].routes.map(
    // eslint-disable-next-line no-return-assign
    (route) =>
      (breadcrumbNameMap = {
        ...breadcrumbNameMap,
        [route.path]: route.titulo,
      })
  )

  const redireciona = (url) => {
    router.history.push({ pathname: url })
  }

  return (
    <Typography component="h2" gutterBottom variant="overline">
      <MemoryRouter initialEntries={['/']} initialIndex={0}>
        <div>
          <Route>
            {() => {
              return (
                <Breadcrumbs separator="-" component="h2" gutterBottom variant="overline" aria-label="breadcrumb">
                  <LinkRouter
                    to={{
                      pathname: '/',
                    }}
                    onClick={() => redireciona('/')}
                  >
                    <Typography component="h2" gutterBottom variant="overline">
                      INÍCIO
                    </Typography>
                  </LinkRouter>

                  {linkRetorno && (
                    <LinkRouter
                      to={{
                        pathname: linkRetorno,
                      }}
                      onClick={() => redireciona(linkRetorno)}
                    >
                      <Typography component="h2" gutterBottom variant="overline">
                        {tituloLinkRetorno}
                      </Typography>
                    </LinkRouter>
                  )}

                  {/* {pathnames.map((value, index) => {
                    const last = index === pathnames.length - 1
                    const to = `/${pathnames.slice(0, index + 1).join('/')}`

                    return last ? (
                      <Typography component="h2" gutterBottom variant="overline" key={to}>
                        {breadcrumbNameMap[to]}
                      </Typography>
                    ) : (
                      <Typography component="h2" gutterBottom variant="overline" key={to}>
                        {breadcrumbNameMap[to]}
                      </Typography>
                    )
                  })} */}
                </Breadcrumbs>
              )
            }}
          </Route>
        </div>
      </MemoryRouter>
    </Typography>
  )
}
